import React from "react";
import TopNavbar from "../../components/TopNavbar/TopNavbar";
import Navbar from "../../components/navbar/navbar";
import Footer from "../../components/footer/footer";
import { GiDiamondRing } from "react-icons/gi";
import "./Aboutus.css";

const AboutUs = () => {
  return (
    <div className="about-us-wrapper">
      <TopNavbar />
      <Navbar />

      <section className="about-hero">
        <div className="container">
          <h1 className="selectpackage_heading text-white">About Us</h1>
        </div>
      </section>

      <div className="container mb-5">
        <div className="row g-4 d-flex justify-content-between">
          {/* Main Content Area */}
          <div className="col-12 col-lg-7 order-2 order-lg-1">
            <h2 className="welcome-text">அன்புடையீர் வணக்கம்!</h2>

            <div className="about-features mt-4">
              <div className="list-item">
                <GiDiamondRing className="icon" />
                <p>நமது கோவை கொங்கு நாடு மேட்ரிமோனி கொங்கு வேளாளக் கவுண்டர்களுக்கு மட்டுமே செயல்படுகிறது.</p>
              </div>

              <div className="list-item">
                <GiDiamondRing className="icon" />
                <p>வரன் பார்க்கும் பெற்றோர் தங்களது மகன் (அல்லது) மகளின் ஜாதகம் போட்டோ மற்றும் பயோடேட்டாக்களை வைத்து ஆன்லைன் அல்லது நமது அலுவலகத்தில் நேரில் வந்தும் பதிவு செய்து கொள்ளலாம்.</p>
              </div>

              <div className="list-item">
                <GiDiamondRing className="icon" />
                <p>நாங்கள் கடந்த 21 வருடங்களாக இந்த திருமணத் தகவல் துறையில் பணியாற்றி அனுபவம் பெற்றுள்ளோம்.</p>
              </div>

              <div className="list-item">
                <GiDiamondRing className="icon" />
                <p>நாங்கள் எந்தவித எதிர்பார்ப்பும் இல்லாமல் சுமார் ஆயிரத்திற்கும் மேற்பட்ட திருமணங்களை வெற்றிகரமாக முடித்துள்ளோம்.</p>
              </div>

              <div className="list-item">
                <GiDiamondRing className="icon" />
                <p>நமது கோவை கொங்குநாடு திருமண தகவல் மையத்தில் பதிவு செய்யும் பதிவு தாரர்களின் முழு விபரங்களும் பாதுகாக்கப்படும்.</p>
              </div>

              <div className="list-item">
                <GiDiamondRing className="icon" />
                <p>பதிவு செய்த பதிவு தாரர்கள் ஆன்லைனிலும் மற்றும் அலுவலகத்திலும் வரன்களை சிறந்த முறையில் தேர்வு செய்து கொள்ளலாம் மற்றும் அவரவர் விருப்பத்திற்கு ஏற்ப தனிப்பட்ட முறையில் நமது அலுவலகத்தின் சார்பில் தேர்ந்தெடுத்து தங்களுக்கு வாட்ஸ் அப் மூலம் அனுப்பி வைக்கப்படும்.</p>
              </div>

              <div className="list-item">
                <GiDiamondRing className="icon" />
                <p>இந்த திருமண சேவையில் சிறப்பாக செயல்பட்டு வரும் எங்களுக்கு தங்களது அன்பையும் ஆதரவையும் தருமாறு அன்போடு கேட்டுக்கொள்கிறோம்.</p>
              </div>
            </div>
          </div>

          {/* Sidebar / Images Area */}
          <div className="col-12 col-lg-5 order-1 order-lg-2">
            <div className="row g-4">

              {/* General About Image Card */}
              <div className="col-12">
                <div className="about-card p-3">
                  <div className="image-container">
                    <img
                      src="https://kovaikongunadumatrimony.com/kkm_images/matrimony_images/kovai_kongunadumatrimony_about_us.png"
                      alt="About Kovai Kongunadu Matrimony"
                      className="founder-img"
                    />
                  </div>
                </div>
              </div>
              {/* Founder Image Card */}
              {/* <div className="col-12">
                <div className="about-card p-4">
                  <div className="image-container">
                    <img
                      src="https://kovaikongunadumatrimony.com/kkm_images/matrimony_images/S.Jeyaprakash.jpeg"
                      alt="S.Jeyaprakash"
                      className="founder-img"
                    />
                  </div>
                  <div className="founder-info">
                    <h3 className="founder-name">S. Jeyaprakash</h3>
                    <p className="founder-title">Founder</p>
                  </div>
                </div>
              </div> */}

            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default AboutUs;
